import React, { PureComponent, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DialogForm from './../../Global/Modals/DialogForm';
import ActivityList from './ActivityList';
import Button from '@material-ui/core/Button';
import ButtonStyles from '../../../styles/button';
const styles = theme => ({
  activityLogContainer: {
    marginTop: theme.spacing.unit * 2,
    width: '60%',
    paddingLeft: theme.spacing.unit * 1.125
  }
});
export class ActivityModal extends PureComponent {
  static propTypes = {
    activities: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  render() {
    const { classes, t, open, onClose, activities } = this.props;
    return (
      <DialogForm
        open={open}
        onClose={onClose}
        refObject={{
          modal: element => (this.modal = element)
        }}
        title={t('Shipment Activity')}
        footer={
          <Fragment>
            <Button
              className={classes.button}
              onClick={onClose}
              color={'primary'}
              classes={{ label: classes.buttonLabel }}
            >
              {t('Ok')}
            </Button>
          </Fragment>
        }
      >
        <div className={classes.activityLogContainer}>
          <ActivityList activities={activities} />
        </div>
      </DialogForm>
    );
  }
}
const translatedActivityModal = withNamespaces()(ActivityModal);
export default withStyles(styles, ButtonStyles)(translatedActivityModal);
